import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BonificacionesextrasComponent } from './components/bonificacionesextras/bonificacionesextras.component';

const routes: Routes = [
  { path: 'bonificacionesextras', component: BonificacionesextrasComponent },
  { path: '', redirectTo: 'bonificacionesextras', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BonificacionesextrasRoutingModule { }
